var map = {
	"./africa": 622,
	"./africa.js": 622,
	"./australia": 711,
	"./australia.js": 711,
	"./bangladesh": 712,
	"./bangladesh.js": 712,
	"./global": 713,
	"./global.js": 713,
	"./india": 714,
	"./india.js": 714,
	"./newzealand": 715,
	"./newzealand.js": 715,
	"./pakistan": 716,
	"./pakistan.js": 716,
	"./srilanka": 717,
	"./srilanka.js": 717,
	"./taboola": 709,
	"./taboola.js": 709,
	"./unitedkingdom": 718,
	"./unitedkingdom.js": 718,
	"./unitedstates": 719,
	"./unitedstates.js": 719
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 621;



//////////////////
// WEBPACK FOOTER
// ../app/lib/utils/editions/config/cricinfo ^\.\/.*$
// module id = 621
// module chunks = 0